import React, { useEffect } from "react";
import "./App.css";
import bymoLogo from "./img/bymo.png";

const Login = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-8S8P00T1SP";
        document.head.appendChild(script);

        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag("js", new Date());
            gtag("config", "G-8S8P00T1SP", { page_path: "/login" });
        };
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '100px',
            background: 'white',
            padding: '100px 20px'
        }}>
            <img
                src={bymoLogo}
                alt="BYMO Logo"
                style={{
                    width: '200px',
                    height: 'auto',
                    marginBottom: '50px'
                }}
            />

            <h1 style={{
                fontSize: '28px',
                fontWeight: '600',
                marginBottom: '25px',
                lineHeight: '1.4',
                color: '#000',
                textAlign: 'center',
                maxWidth: '600px'
            }}>
                Improved communication with our partners
            </h1>

            <p style={{
                fontSize: '18px',
                lineHeight: '1.6',
                marginBottom: '20px',
                width: '500px',
                color: '#000',
                textAlign: 'center'
            }}>
                You will receive all commissions and communication directly on <strong>bymo.ro</strong>. Use the same email to access your account.
            </p>

            <p style={{
                fontSize: '16px',
                lineHeight: '1.6',
                marginTop: '40px',
                color: '#666',
                textAlign: 'center'
            }}>
                Thank you for being part of the BYMO Athletes community
            </p>
        </div>
    );
};

export default Login;
